<template>
  <div>
    <component :is="view"> </component>
  </div>
</template>

<script>
import Spve from './Sprc.vue'
import True from './True.vue'
import Demo from './Demo.vue'
export default {
  computed: {
    view() {
      if (['TRUEIDTEST', 'TRUEID'].includes(this.$store.state.apiKey)) {
        return 'True'
      } else if (this.$store.state.apiKey == 'SPVC') {
        return 'Spve'
      } else if (this.$store.state.apiKey == 'DEMO') {
        return 'Demo'
      } else {
        return 'Spve'
      }
    }
  },
  components: {
    Spve,
    True,
    Demo
  }
}
</script>

<style lang="scss" scoped></style>
